<template>
  <div>
    <v-data-table
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      hide-default-footer
      :headers="headers"
      :loading="loading"
      :items-per-page="-1"
      :items="menuListDisplay"
      @click:row="rowClicked"
      no-data-text="Không có dữ liệu"
      disable-sort
    >
      <template v-slot:[`item.weekDay`]="{ item }">
        <span v-if="item.commonInfor">
          {{ (item.day != 7 ? item.day : 0) | scheduleDay }}
        </span>
        <span v-else class="text--secondary">{{ item.name }}</span>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span v-if="item.commonInfor">
          <span v-if="item.date">{{ item.date }}</span>
          <span v-else>
            {{
              moment(startWeek)
                .startOf('day')
                .add(item.day - 1, 'day')
                .toISOString() | ddmmyyyy
            }}
          </span>
        </span>
        <span v-else></span>
      </template>
      <template v-slot:[`item.menu1`]="{ item }">
        <div v-if="item.commonInfor">
          <div v-if="$_get(item, 'firstMainDishes.length')">
            Có
            <span class="text-h6 success--text">
              {{ $get(item, 'selectedMenu1Count', 0) }}
            </span>
            suất đăng ký
          </div>
          <div v-else class="error--text">Chưa có thông tin</div>
        </div>
        <div v-else>
          <div
            v-if="item.type !== 'action' && $_get(item.menu1List, 'length')"
            :class="item.type === 'main' ? 'd-flex align-center' : ''"
          >
            <div v-for="dish in item.menu1List" :key="dish.id" class="mr-2">
              <div v-if="dish.type === 'main'" class="image-wrapper my-2">
                <v-img v-if="dish.image" :src="dish.image.url" alt="" contain></v-img>
              </div>
              {{ dish.name }}
            </div>
          </div>
          <div v-else-if="item.type !== 'action' && item.type !== 'viewDetail'">Chưa có món ăn</div>
          <div v-else-if="item.type === 'action'">
            <v-btn small color="primary" class="text-none" @click="editMenu(item, 'menu1')" outlined>
              <v-icon left>mdi-pencil</v-icon>
              Cập nhật</v-btn
            >
          </div>
          <div v-else>
            <span @click="goToStudentMenuRegist(item, 'menu1')" class="primary--text cursor-pointer font-weight-bold"
              >Xem chi tiết đăng ký</span
            >
          </div>
        </div>
      </template>
      <template v-slot:[`item.menu2`]="{ item }">
        <div v-if="item.commonInfor">
          <div v-if="$_get(item, 'secondMainDishes.length')">
            Có
            <span class="text-h6 success--text">
              {{ $get(item, 'selectedMenu2Count', 0) }}
            </span>
            suất đăng ký
          </div>
          <div v-else class="error--text">Chưa có thông tin</div>
        </div>
        <div v-else>
          <div
            v-if="item.type !== 'action' && $_get(item.menu2List, 'length')"
            :class="item.type === 'main' ? 'd-flex align-center' : ''"
          >
            <div v-for="dish in item.menu2List" :key="dish.id" class="mr-2">
              <div v-if="dish.type === 'main'" class="image-wrapper my-2">
                <v-img v-if="dish.image" :src="dish.image.url" alt="" contain></v-img>
              </div>
              {{ dish.name }}
            </div>
          </div>
          <div v-else-if="item.type !== 'action' && item.type !== 'viewDetail'">Chưa có món ăn</div>
          <div v-else-if="item.type === 'action'">
            <v-btn small color="primary" class="text-none" @click="editMenu(item, 'menu2')" outlined>
              <v-icon left>mdi-pencil</v-icon>
              Cập nhật</v-btn
            >
          </div>
          <div v-else>
            <span @click="goToStudentMenuRegist(item, 'menu2')" class="primary--text cursor-pointer font-weight-bold"
              >Xem chi tiết đăng ký</span
            >
          </div>
        </div>
      </template>
      <template v-slot:[`item.expand`]="{ item }">
        <div v-if="item.commonInfor">
          <v-icon v-if="item.expanded">mdi-unfold-less-horizontal</v-icon>
          <v-icon v-else>mdi-unfold-more-horizontal</v-icon>
        </div>
      </template>
    </v-data-table>
    <FoodMenuEditDialog :dayProp="selectedDay" :menu="menuEdit" :state="editDialog" />
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'

const originHeaders = [
  { text: 'Thứ', value: 'weekDay' },
  { text: 'Ngày', value: 'date' },
  { text: 'Thực đơn 1', value: 'menu1' },
  { text: 'Thực đơn 2', value: 'menu2' },
  { text: '', width: 100, value: 'expand', align: 'end' },
]

export default {
  components: { FoodMenuEditDialog: () => import('@/modules/foodMenu/FoodMenuEditDialog.vue') },
  data() {
    return {
      headers: originHeaders,
      moment,
      expanded: [],
      editDialog: false,
      selectedDay: 0,
      menuEdit: 'menu1',
    }
  },
  async created() {
    await this.refresh()
  },
  computed: {
    ...mapState('FoodMenu', ['loading', 'menuListDisplay']),
    ...mapGetters('FoodMenu', ['startWeek']),
  },
  methods: {
    ...mapActions('FoodMenu', ['fetchData', 'expandInfo']),
    async refresh() {
      await this.fetchData()
    },
    rowClicked(item) {
      if (item.commonInfor) this.expandInfo(item.day)
    },
    editMenu(item, menu) {
      this.menuEdit = menu
      this.selectedDay = +item.day
      this.editDialog = !this.editDialog
    },

    goToStudentMenuRegist(item, menu) {
      const toAddDays = item.day - 1
      const date = moment(this.startWeek).startOf('day').add(toAddDays, 'day').toISOString()
      window.open(`/student-menu-register?date=${date}&menu=${menu}`, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.border {
  border-bottom: 1px solid lightgray;
}
.expand-info {
  background: lightblue !important;
}
.image-wrapper {
  width: 55px;
  min-width: 55px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
</style>
